jQuery('document').ready(function () {
    /* LPs */
    jQuery('.trigger-search').click(function (e) {
        e.preventDefault();
        jQuery(this).hide();
        jQuery('.brand--link li.search-form form').addClass('is-open');
    });

    jQuery('.trigger-search-close').click(function (e) {
        e.preventDefault();
        jQuery('.brand--link li.search-form form').removeClass('is-open');
        jQuery('.trigger-search').show();
    });

    jQuery('.trigger-mobile').click(function (e) {
        e.preventDefault();

        jQuery('.lps--section__mobile').addClass('is-open');
    });

    jQuery('.trigger-mobile-close').click(function (e) {
        e.preventDefault();

        jQuery('.lps--section__mobile').removeClass('is-open');
    });

    jQuery('.js-lp-logo').owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        items: 2,
        autoplay: true,
        autoplaySpeed: 300,
        margin: 15,
        autoHeight: true,
        responsive: {
            0: {
                items: 2
            },
            768: {
                items: 4,
                loop: false,
                autoplay: false,
                margin: 80
            }
        }
    });

    /*
    jQuery('.js-video-carousel').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        items: 2,
        autoplay: false,
        autoplaySpeed: 300,
        margin: 10,
        autoHeight: true,
        video: true,
        responsive: {
            768: {
                items: 4,
                margin: 15
            },
            1200: {
                items: 5,
                margin: 15,
                nav: true,
                dots: false
            }
        }
    });
    */


    jQuery(document).ready(function ($) {
    const $carousel = $('.js-video-carousel');

    // video_tag doesn't support playsinline — patch it in so iOS doesn't force fullscreen
    $carousel.find('.js-video').attr('playsinline', '');

    // Lazy-load: with preload:'none' the file itself won't fetch until .play()/.load()
    // is called, so we just avoid calling those until a card is near viewport.
    const lazyObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const $card = $(entry.target);
            $card.data('in-viewport', entry.isIntersecting);
            if (!entry.isIntersecting) {
                // Optional: pause anything that scrolls fully offscreen
                const video = $card.find('.js-video')[0];
                if (video && !video.paused) {
                    video.pause();
                }
            }
        });
    }, { rootMargin: '200px 0px' });

    $carousel.find('.video-card').each(function () {
        lazyObserver.observe(this);
    });

    $carousel.owlCarousel({
        loop: true,
        dots: false,           // dots aren't needed per these requirements; nav arrows carry navigation
        nav: true,              // arrows visible on all breakpoints now, not just desktop
        center: true,
        autoplay: true,
        autoplayTimeout: 8000,  // dwell time per slide
        autoplayHoverPause: true,
        smartSpeed: 600,        // manual/nav-triggered transition speed
        autoplaySpeed: 600,     // auto-advance transition speed — same value, so it's not jarring
        autoHeight: true,
        items: 1,               // mobile default: one full-width video at a time
        margin: 0,
        responsive: { 
            768: {
                items: 3,
                margin: 15,
                center: true
            },
            1200: {
                items: 4,
                margin: 15,
                center: true
            }
        }
    });

    // ---------- Shared state ----------
    let $activeCard = null;

    // Pause auto-advance while someone is actively (unmuted) watching a
    // card, so the carousel doesn't yank the video away mid-playback;
    // resume once nothing is actively playing.
    function setActiveCard($card) {
        $activeCard = $card;
        $carousel.trigger('stop.owl.autoplay');
    }

    function clearActiveCard() {
        $activeCard = null;
        $carousel.trigger('play.owl.autoplay');
    }

    function stopCard($card) {
        if (!$card || !$card.length) return;
        const video = $card.find('.js-video')[0];
        if (!video) return;
        video.pause();
        video.muted = true;
        $card.removeClass('is-active is-previewing');
        $card.find('.js-mute-toggle')
            .attr('aria-pressed', 'false')
            .attr('aria-label', 'Unmute video');
    }

    function stopAllExcept($except) {
        $carousel.find('.video-card').each(function () {
            const $card = $(this);
            if (!$except || $card[0] !== $except[0]) {
                stopCard($card);
            }
        });
    }

    function previewCenterVideo() {
        const $center = $carousel.find('.owl-item.center').find('.video-card');
        if (!$center.length) return;

        if ($activeCard && $activeCard[0] !== $center[0]) {
            stopCard($activeCard);
            clearActiveCard();
        }

        stopAllExcept($center);

        const video = $center.find('.js-video')[0];
        if (video && video.paused) {
            video.muted = true;
            video.play().catch(() => {});
            $center.addClass('is-previewing');
        }
    }

    $carousel.on('translated.owl.carousel initialized.owl.carousel', previewCenterVideo);

    // ---------- Click card: focus, unmute, play / toggle off ----------
    $carousel.on('click', '.video-card', function (e) {
        if ($(e.target).closest('.js-mute-toggle').length) return;

        const $card = $(this);
        const video = $card.find('.js-video')[0];
        if (!video) return;

        const isCurrentlyActive = $card.hasClass('is-active');

        stopAllExcept($card);

        if (isCurrentlyActive) {
            stopCard($card);
            clearActiveCard();
        } else {
            video.muted = false;
            video.play().catch(() => {});
            $card.addClass('is-active').removeClass('is-previewing');
            $card.find('.js-mute-toggle')
                .attr('aria-pressed', 'true')
                .attr('aria-label', 'Mute video');
            setActiveCard($card);
        }
    });

    // ---------- Dedicated mute/unmute button ----------
    $carousel.on('click', '.js-mute-toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $btn = $(this);
        const $card = $btn.closest('.video-card');
        const video = $card.find('.js-video')[0];
        if (!video) return;

        video.muted = !video.muted;
        $btn.attr('aria-pressed', String(!video.muted));
        $btn.attr('aria-label', video.muted ? 'Unmute video' : 'Mute video');

        if (!video.muted && video.paused) {
            stopAllExcept($card);
            video.play().catch(() => {});
            $card.addClass('is-active');
            setActiveCard($card);
        }
    });

    // ---------- Moving focus away mutes + pauses ----------
    $carousel.on('focusout', '.video-card', function (e) {
        const $card = $(this);
        if ($card.has(e.relatedTarget).length) return;

        if ($card.hasClass('is-active')) {
            stopCard($card);
            if ($activeCard && $activeCard[0] === $card[0]) {
                clearActiveCard();
            }
        }
    });
});



    jQuery('.js-steps').owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        items: 2,
        autoplay: true,
        autoplaySpeed: 300,
        margin: 15,
        autoHeight: true,
        responsive: {
            0: {
                items: 1,
                dots: true,
                mouseDrag: true,
                touchDrag: true
            },
            768: {
                items: 3,
                loop: false,
                autoplay: false,
                margin: 80,
                dots: false,
                mouseDrag: false,
                touchDrag: false
            }
        }
    });


    jQuery('.js-ingredients').owlCarousel({
        loop: true,
        nav: true,
        dots: true,
        items: 2,
        autoplay: true,
        autoplaySpeed: 300,
        margin: 15,
        autoHeight: true,
        responsive: {
            0: {
                items: 1,
                dots: true
            },
            768: {
                items: 3,
                loop: false,
                autoplay: false,
                margin: 80,
                dots: false
            }
        }
    });

    // Visual-cards mobile layout: all rows try to fit in one view (nav/dots
    // switch off once they do); below that width it's a swipeable carousel.
    jQuery('.js-ingredients-cards').owlCarousel({
        // loop: true,
        nav: true,
        dots: true,
        items: 1.15,
        margin: 16,
        // autoHeight: true,
        responsive: {
            0: {
                items: 1,
                nav: true,
                dots: true,
                margin: 10,
            },
            560: {
                items: 3,
                loop: false,
                nav: false,
                dots: false,
                margin: 16
            }
        }
    });


    jQuery('.js-testimonial-slider').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        items: 2,
        autoplay: true,
        autoplaySpeed: 300,
        autoHeight: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            }
        }
    });

    const sync1 = jQuery('.js-lp-gallery');
    const sync2 = jQuery('.js-lp-gallery--thumb');
    const slidesPerPage = 3;
    let syncedSecondary = true;

    sync1.owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        items: 1,
        autoplay: true,
        autoplaySpeed: 300,
        autoplayTimeout: 6000,
        autoHeight: true,
        responsive: {
            768: {
                dots: false
            }
        }
    }).on('changed.owl.carousel', syncPosition);;

    sync2.on('initialized.owl.carousel', function () {
        sync2.find(".owl-item").eq(0).addClass("current");
    })
        .owlCarousel({
            items: slidesPerPage,
            dots: false,
            nav: false,
            smartSpeed: 200,
            slideSpeed: 500,
            margin: 20,
            slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
            responsiveRefreshRate: 100
        }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        //var current = el.item.index;

        //if you disable loop you have to comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        //end block

        sync2
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });



    jQuery('.faq--question').click(function (e) {
        e.preventDefault();

        const _this = jQuery(this);
        jQuery('.faq--answer, .faq--question').removeClass('is-open');
        _this.toggleClass('is-open');
        _this.siblings('.faq--answer').toggleClass('is-open');
    });


    /*jQuery('.collapsible--question').click(function (e) {
        e.preventDefault();

        const _this = jQuery(this);
        const _answer = _this.siblings('.collapsible--answer');

        // Only open if not already open (one-time open behavior)
        if (!_this.hasClass('is-open')) {
            _this.addClass('is-open');
            _answer.addClass('is-open');
        }
        // If already open, do nothing (prevent closing)

    });
    */
   jQuery('.collapsible--question').click(function (e) {
        // If there's a link inside the question and the click was on it, let it work normally
        if (jQuery(e.target).closest('a').length) {
            const _link = jQuery(e.target).closest('a');
            const _href = _link.attr('href');

            // Only handle in-page anchor links (e.g. href="#section")
            if (_href && _href.charAt(0) === '#' && _href.length > 1) {
                const _target = '.' + _href.substr(1); // strip '#', build class selector
                const _anchor = jQuery(_target); // now wrap the selector string in jQuery

                console.log(_target);

                if (_anchor.length) {
                    jQuery('html, body').animate({
                        scrollTop: _anchor.offset().top - 100
                    });
                }

                console.log(_href);
            }

            // Let external/non-anchor links behave normally (don't return early in that case
            // unless you specifically want to block the accordion toggle too)
            return;
        } else {
            // The featured-product section manages its own open/close toggle
            // (see its inline <script>) — this branch is open-only by design
            // for the other LP sections, so leave that section's own toggle
            // alone or the two handlers fight each other.
            if (jQuery(this).closest('.module--featured-product').length) {
                return;
            }

            e.preventDefault();

            const _this = jQuery(this);
            const _answer = _this.siblings('.collapsible--answer');

            // Only open if not already open (one-time open behavior)
            if (!_this.hasClass('is-open')) {
                _this.addClass('is-open');
                _answer.addClass('is-open');
            }
            // If already open, do nothing (prevent closing)
        }

        

    });
    

    const _stickyHeader = jQuery('.lps--section lps--section__header');
    const _galleryParent = jQuery('.product--gallery');
    const _galleryWrapper = jQuery('.gallery--wrapper');
    const _nextSection = jQuery('.module--featured-product + .shopify-section');

    jQuery(window).scroll(function () {

        // if( scrollY > (jQuery(window).height()) ) {
        if (scrollY > 1500) {
            jQuery('.sticky-cart').addClass('is-open');
        } else {
            jQuery('.sticky-cart').removeClass('is-open');
        }


        if (jQuery(window).width() > 767) {

            let _nextSectionPos = _nextSection.offset().top;
            let _testScroll = scrollY + jQuery(window).height();

            let _top = _stickyHeader.height() + 20; //_galleryParent.offset().top;
            let _left = _galleryParent.offset().left;
            let _width = _galleryParent.width();

            if (_testScroll - (jQuery(window).height() / 4) >= _nextSectionPos) {
                _galleryWrapper.addClass('not-visible');
            } else if (_testScroll < _nextSectionPos && (scrollY + 120) > _galleryParent.offset().top) {
                _galleryWrapper.css({
                    position: 'fixed',
                    zIndex: 1,
                    top: 120 + 'px',
                    left: _left + 'px',
                    width: _width + 'px'
                });
                _galleryWrapper.removeClass('not-visible');

            } else if (scrollY < _galleryParent.offset().top) {
                _galleryWrapper.css({
                    position: 'static'
                });
                _galleryWrapper.removeClass('not-visible');

            }
        }
    });

    jQuery('.product--choice .plan').click(function (e) {
        const isSub = jQuery(this).hasClass('plan-sub');

        if (isSub) {
            jQuery('.form-plan').hide();
            jQuery('.form-plan.sub').show();

            jQuery('.form-plan.sub input[name="selling_plan"]').val(jQuery(this).attr('id'));
        } else if (jQuery(this).hasClass('plan-one')) {
            jQuery('.form-plan').hide();
            jQuery('.form-plan.one').show();
        }

        jQuery('.product--choice .plan.active').show();
    });

    jQuery('.product--choice .plan.active').click(function (e) {
        let _html = '';

        jQuery('.product--choice .plan-choice').show();

        jQuery('.product--choice .plan:not(.active)').click(function (e) {
            _html = jQuery(this).html();

            jQuery('.product--choice .plan.active').html(_html);
            jQuery('.product--choice .plan-choice').hide();
        });

    });

    if (jQuery('.plan-choice').children('li').length <= 1) {
        jQuery('.plan-choice').parent().find('.plan.active').addClass('one-time')
    } else {
        jQuery('.plan.active span.one-time').remove()
    }

    if (jQuery('.plan.active ').find('span.sub_plan')) {
        // jQuery('.plan.active span.one-time').remove()
    }

    jQuery('.subscription-panel .plan').click(function(){
        const _plan = jQuery(this).data('plan');

        jQuery('.subscription-panel .plan').removeClass('active');
        jQuery(this).addClass('active');

        if( _plan !== null ) {
            jQuery('.form-plan #js-plan').val( _plan );
        } else {
            jQuery('.form-plan #js-plan').val( null );
        }
    });

    jQuery('.subscription--choice ul li.deets .open').click(function(){
        jQuery('.js-deets .details').fadeIn();
    });

    jQuery('.js-deets .details .close').click(function(){
        jQuery('.js-deets .details').fadeOut();
    });

    jQuery('.js-how-to-use-trigger').click(function(){
        jQuery('.js-how-to-use-modal').addClass('is-open');
        jQuery('body').addClass('overflow-hidden');
    });

    jQuery('.js-how-to-use-close').click(function(){
        jQuery('.js-how-to-use-modal').removeClass('is-open');
        jQuery('body').removeClass('overflow-hidden');
    });

    jQuery(document).keyup(function(e){
        if (e.key === 'Escape') {
            jQuery('.js-how-to-use-modal').removeClass('is-open');
            jQuery('body').removeClass('overflow-hidden');
        }
    });
});